/**
 * Created by vsuthar on 9/24/21
 * File: StatusRenderer
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { sortedUniq } from 'lodash'
/**
 *   TODO: Brief what is this component/class do
 */
import { useEffect, useMemo, useState } from 'react'
import StatusCalculator from '../../../../common/components/status/StatusCalculator'
import './statusRenderer.scss'
import StatusBar from './StatusBar'
import { ARRAY } from '../../../../common/utils/Utils'
import { APP_ID_PRISMA_ACCESS_PANORAMA } from '../../../../common/constants/GlobalConstants'
import { LICENSE_STATUS_COMPLETE, LICENSE_STATUS_RUNNING } from '../../../constants/TenancyConstants'

const StatusRenderer = (props) => {

  const { row, value, data } = props

  const [status, original] = useMemo(() => {
    let status = value
    let original = row?.original
    /**
     * APPORTAL-6212 Below logic has been done due to Panorama status stays initializing after migration.
     */

    if (original?.app_id === APP_ID_PRISMA_ACCESS_PANORAMA && original?.status === LICENSE_STATUS_RUNNING) {
      original.provisioning_status = LICENSE_STATUS_COMPLETE
    }

    if (row?.depth === 0 && ARRAY.hasArray(row?.subRows) && !row?.isExpanded) {
      original = row?.subRows[0]?.original
      status = original?.status || original?.provisioning_status
    }
    return [status, original]
  }, [row?.depth, row?.isExpanded, row?.original, row?.subRows, value])

  const [tsgList, setTsgList] = useState([])
  const [instanceData, setInstanceData] = useState([])

  useEffect(() => {
    setTsgList(() => {
      const output = []
      if (original?.tsg_id !== original?.id) {
        output.push(original?.tsg_id)
      }
      else {
        output.push(original?.id)
        original?.children?.forEach((each) => {
          output.push(each.id)
        })
      }
      return sortedUniq(output)
    })
    // setShowStatus((prev) => (!status ? false : prev))
    setInstanceData((prev) => {
      if (original?.tsg_id !== original?.id) {
        return [original]
      }
      else {
        return original?.instances?.filter((each) => {
          return each.provisioning_status && each.app_id === original?.app_id
        })
      }
    })
  }, [status, original, setInstanceData, data])

  return (
    <div className='tw-h-full tw-w-full tw-flex tw-flex-col cm-py-2'>
      {status ? (
        <StatusCalculator isIndividual {...{ instanceData, tsgList, ...props }}>
          <StatusBar {...{ instanceData }} />
        </StatusCalculator>
      ) : null}
    </div>
  )
}

StatusRenderer.propTypes = {}

export default StatusRenderer
